import React, {Component} from 'react';
import {Field, reduxForm} from "redux-form";
import {required} from "../validators";
import OrangeLinkWithArrow from "./OrangeLinkWithArrow";
import {withStyles} from '@material-ui/core/styles';
import classNames from 'classnames';


class EmailSubscribeForm extends Component {
  clickedField = () => {
    window.analytics.track('Newsletter - Clicked Email Field', {location: 'Footer'});
  };

  render() {
    const {valid, submitting, classes, handleSubmit, className} = this.props;

    return (
      <form onSubmit={handleSubmit} className={classNames(classes.form, className)}>
        <div className={classes.ui}>
          <Field
            className={classes.field}
            component='input'
            type='email'
            name='email'
            placeholder={'Enter your email to get our newsletter'}
            onClick={this.clickedField}
            validate={[required]}
          />
          <OrangeLinkWithArrow
            disabled={!valid}
            type="submit">{(submitting) ? 'Subscribing' : 'Subscribe'}</OrangeLinkWithArrow>
        </div>
        <div className={classes.message}>
          Receive priority updates on all things Gridhaus.
        </div>
      </form>
    );
  }
}

export default withStyles(theme => ({
  form: {
    maxWidth: 560,
  },
  ui: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: theme.spacing.unit,
  },
  field: {
    width: '100%',
    color: theme.palette.secondary.main,
    ...theme.typography.hg18r(theme),
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
    '&::placeholder': {
      color: theme.palette.secondary.main,
      ...theme.typography.hg18r(theme),
    },
    marginBottom: 15,
    marginRight: 25,
  },
  message: {
    ...theme.typography.hg14r(theme),
    color: theme.palette.darkGrey,
  },
  [theme.breakpoints.up(768)]: {
    ui: {
      flexDirection: 'row',
    },
    field: {
      marginBottom: 0,
    }
  },
}))(reduxForm({
  form: 'emailSubscribeForm'
})(EmailSubscribeForm));



// WEBPACK FOOTER //
// ./src/parts/EmailSubscribeForm.js